<template>
  <v-row v-if="images" class="mt-4">
    <v-col>
      <v-card class="v-card--no-style mt-3">
        <h2>Galeria</h2>
      </v-card>

      <v-row>
        <v-col
          v-for="(item, galleryIndex) in images"
          :key="'gallery_index_' + galleryIndex"
          cols="6"
          sm="4"
          md="3"
          xs4
          md3
          xl2
        >
          <v-hover>
            <v-img
              slot-scope="{ hover }"
              aspect-ratio="1"
              cover
              class="gallery-image"
              lazy-src="/img/gallery-lazy-image.jpg"
              :src="mediaUrl + item"
              :class="`elevation-${hover ? 4 : 0}`"
              @click="showImg(galleryIndex)"
            />
          </v-hover>
        </v-col>
      </v-row>

      <v-dialog v-model="showGalleryModal" max-width="70%" transition="dialog-transition" :overlay="false">
        <v-card dark>
          <v-carousel
            height="80vh"
            next-icon="mdi-chevron-right"
            prev-icon="mdi-chevron-left"
            :cycle="false"
            :value="index"
          >
            <v-carousel-item
              v-for="(item, carouselIndex) in images"
              :key="'carousel_index_' + carouselIndex"
              contain
              :src="mediaUrl + item"
            />
          </v-carousel>
        </v-card>
      </v-dialog>
    </v-col>
  </v-row>
</template>

<script>
import { mediaMixin } from '@/mixins/media';

// @vuese
// Galeria obrazków do wyświetlenia
// @group Partials
export default {
  mixins: [mediaMixin],
  props: {
    // Lista media id do wyświetlenia
    images: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      showGalleryModal: false,
      index: undefined
    };
  },
  watch: {
    showGalleryModal(val) {
      if (!val) {
        this.index = undefined;
      }
    }
  },
  methods: {
    // @vuese
    // Wyświetla powiększony obrazek w modalu
    showImg(index) {
      this.showGalleryModal = true;
      this.index = index;
    }
  }
};
</script>

<style lang="scss">
.gallery-image {
  margin: 5px;
  cursor: pointer;
}
.gallery-image > .v-image__image--preload {
  filter: none !important;
}
</style>
